module.exports = {"path":"/404.html","body":"<h1>NOT FOUND</h1>\n<p>You just hit a route that doesn’t exist… the sadness.</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./404.md
 ** module id = 474
 ** module chunks = 0
 **/